export default __webpack_public_path__ + "static/cup-fd3219028c948b55a29c0c00e3566641.png";